import { buildBinderListings } from '@monofe/di';
import buildA2HS from './a2hs/bind';
import buildHistory from './history/bind';
import buildRouter from './router/bind';

export default buildBinderListings([buildHistory, buildRouter, buildA2HS]);
